/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const confirmBookingInputSchema = z.object({
	scheduledAt: z.iso.datetime(),
	candidateTimezone: z.string(),
})

export type ConfirmBookingInputSchema = z.infer<typeof confirmBookingInputSchema>
